<template>
  <div class="step">
    <div class="background-bottom" :class="{'bottom-history': history}">
    </div>

    <div :class="coverClass" class="background-cover" >

    </div>
    <div class="item-wapper">
      <div class="step-item" v-for="(item, i) in dataList()" :key="i">
        <div class="image" :class="currentImageClass(i)"></div>
        <div @click="click(i)" class='status-step' :class="currentStatusClass(i)">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'welfare-step',
  props: {
    welfareItem: {
      type: Object,
      default: Object
    },
    history: {
      type: Boolean, // 标识是否是历史
      default: false
    },
    type: {
      type: String,
      default: 'REDUCTION_INTEREST' // NEW_PERSON表示新人， REDUCTION_INTEREST表示活动
    },
    index: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      newcomerList: [
        {
          index: 0,
          name: '实名领红包'
        },
        {
          index: 1,
          name: '去借款'
        },
        {
          index: 2,
          name: '提现红包'
        }
      ], 
      mianxilist: [
        {
          index: 0,
          name: '授信领红包'
        },
        {
          index: 1,
          name: '去借款'
        },
        {
          index: 2,
          name: '去还款'
        }
      ]
    }
  }, 
  computed: {
    coverClass () {
      if (this.history) {
        return `background-cover-${this.index} cover-history`
      }
      return `background-cover-${this.index}`
    }
  }, 
  methods: {
    currentImageClass (i) {
      if (this.history) {
        if (i < this.index) {
          return 'selected-history'
        } else {
          return 'unselected-history'
        }
      } else {
        if (i < this.index) {
          return 'selected'
        } else {
          return 'unselected'
        }
      }
    }, 
    currentStatusClass (i) {
      let classstring = ''
      if (this.index === -1) {
        classstring = (i === 0) ? 'unstart' : 'after'
      } else if (i < this.index) {
        classstring = 'before'
      } else if (i === this.index) {
        classstring = 'current'
      } else {
        classstring = 'after'
      }
      if (this.history) {
        return `${classstring} status-history`
      }
      return classstring
    }, 
    dataList () {
      if (this.type === 'REDUCTION_INTEREST') {
        return this.mianxilist
      } else {
        return this.newcomerList
      }
    }, 
    click (i) {
      if (i === 0) {
        this.$emit('click', 0)
      } else if (this.index === i) {
        this.$emit('click', this.index)
      }
    }
  }
}
</script>
<style lang='less'>
@import "../../../assets/less/mixin.less";

  .step{
    position: relative;
    .background-bottom {
      position: absolute;
      left: 110px;
      right: 100px;
      top: 8px;
      height: 8px;
      background: #FFCBBC;
      border-radius: 12px;
      &.bottom-history {
          background: #BDBDBD;
      }
    }
    .background-cover {
      position: absolute;
      left: 110px;
      // right: 100px;
      top: 8px;
      height: 8px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 12px;
      &.background-cover-0 {
        width: 0%;
      }

      &.background-cover-1 {
        width: 20%;
      }

      &.background-cover-2 {
        width: 50%;
      }

      &.background-cover-3 {
        width: 65%;
      }
      &.cover-history {
          background: #858585;
      }
    }
    .item-wapper {
        width: 100%;
        position: absolute;

        display: flex;
        justify-content: space-around;

        .step-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          .image {
            width: 24px;
            height: 24px;
          }
          .selected {
            background-size: 100% 100%;
            background-image: url('./icon_dian01@2x.png');
          }
          .unselected {
            background-size: 100% 100%;
            background-image: url('./icon_dian02@2x.png');
          }
        .selected-history {
            background-size: 100% 100%;
            background-image: url('./icon_dian03@2x.png');
          }

        .unselected-history {
            background-size: 100% 100%;
            background-image: url('./icon_dian04@2x.png');
          }
          .status-step {
            margin-top: 25px;
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FF4633;
            line-height: 40px;
            text-align: center;
            width: 145px;
            height: 40px;
            border: 0px solid #FF4633;

            &.unstart {
                color: #FF4633;
                border-radius: 20px;
                border: 1px solid #FF4633;
                
                  &.status-history {
                    border: 1px solid #666666;
                  }
            }
            &.after {
                color: #666666;
            }
            &.before {
                color: #FF4633;
            }
            &.current {
                border-radius: 20px;
                border: 1px solid #FF4633;
                &.status-history {
                  border: 1px solid #666666;
                }
            }
            &.status-history {
                color: #666666;
            }
          }
        }
    }
  }
</style>